import { MCCustomAsyncValidatorFunctions } from "@maslul/common-services";

export class CustomAsyncValidatorFunctions extends MCCustomAsyncValidatorFunctions {
}
